import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';

import {
  GET_AGENDA_REQUEST,
  SET_COMPLETADO_EVENTO,
  DELETE_EVENT,
  CREATE_EVENT,
  UPDATE_EVENT,
} from '../../actions/constants/agenda/agenda.constants';
import { authRequest } from '../../../helpers/request.helper';
import {
  getAgendaFailureAction,
  getAgendaSuccessAction,
  addEventsCalendar,
  resetEventos,
  getAgendaAction,
} from '../../actions/creators/agenda/agenda.actioncreator';

const getAgendaFromState = state => state.agenda;

function* getAgenda(action) {
  const { payload } = action;
  const {
    page, start, limit, tipoTarea, mesActivo,
  } = payload;
  const agendaFromState = yield select(getAgendaFromState);

  const { listado } = agendaFromState;
  // console.log(agendaFromState);
  // console.log(tipoTarea);


  let url = `agenda/?page=${page}&start=${start}&limit=${limit}`;
  const filtros = [];

  filtros.push({
    property: 'tipo_tarea', value: tipoTarea, operator: 'in',
  });

  if (mesActivo) {
    const mes = mesActivo.getMonth() + 1;
    const anyo = mesActivo.getFullYear();
    filtros.push({
      property: 'mes_activo', value: `${anyo}-${mes}`, operator: 'in',
    });
  }

  const queryString = encodeURIComponent(JSON.stringify(filtros));
  url += `&filter=${queryString}`;

  const params = {
    url,
    method: 'GET',
  };

  try {
    const response = yield call(authRequest, params);
    const { datos, success, total } = response;
    if (success) {
      for (let index = 0; index < datos.length; index += 1) {
        datos[index].start = new Date(datos[index].start);
        datos[index].end = new Date(datos[index].end);
      }
      yield (put(addEventsCalendar(datos)));
      yield put(getAgendaSuccessAction(datos, total, page, start, limit));
    } else {
      yield put(getAgendaFailureAction());
    }
  } catch (error) {
    yield put(getAgendaFailureAction(error));
  }
}

function* setCompletadoEvento(action) {
  const { payload } = action;
  const {
    id: idEvento,
  } = payload;

  const params = {
    url: `agenda/hacerODeshacerCompletado?id=${idEvento}`,
    method: 'POST',
  };

  const response = yield call(authRequest, params);
  // const { id, success } = response;
  // if (success) {
  //   window.location.href = `${window.location.origin}/#/noconformidades/editar/${id}`;
  // }
}

function* deleteEvent(action) {
  const { payload } = action;
  const {
    id: idEvento, valueDeleteGroup,
  } = payload;

  const formData = new FormData();
  formData.append('id', idEvento);
  formData.append('value_delete_group', valueDeleteGroup);

  const params = {
    url: 'agenda/delete',
    method: 'POST',
    body: formData,
  };

  const response = yield call(authRequest, params);
  const { id, success, fecha_orig } = response;
  const { date } = fecha_orig;
  if (success) {
    yield (put(resetEventos()));
    yield (put(getAgendaAction(1, 0, 9999, '1,2', new Date(date))));
  }
}

function* createEvent(action) {
  const { payload } = action;
  const { values } = payload;
  const {
    titulo, fecha_hora: fechaHora, repetir, descripcion,
  } = values;

  const formData = new FormData();
  formData.append('id', null);
  formData.append('titulo', (titulo || ''));
  formData.append('descripcion', (descripcion || ''));
  formData.append('tipo_tarea', 1);
  formData.append('repetir', repetir);
  formData.append('fecha_hora_ini', fechaHora);

  const params = {
    url: 'agenda/create',
    method: 'POST',
    body: formData,
  };

  const response = yield call(authRequest, params);
  const { nuevo_id: datos, success } = response;
  const { nuevo_id: nuevoId } = datos;
  if (success) {
    yield (put(resetEventos()));
    yield (put(getAgendaAction(1, 0, 9999, '1,2', new Date(fechaHora))));
  }
}


function* updateEvent(action) {
  const { payload } = action;
  const { values } = payload;
  const {
    id, titulo, fecha_hora, repetir, descripcion, tipoCambioRepGrupo,
  } = values;

  const formData = new FormData();
  formData.append('id', id);
  formData.append('titulo', (titulo || ''));
  formData.append('descripcion', (descripcion || ''));
  formData.append('repetir', repetir);
  formData.append('fecha_hora_ini', fecha_hora);
  formData.append('tipo_cambio_repeticion_grupo', (tipoCambioRepGrupo || ''));

  const params = {
    url: 'agenda/update',
    method: 'POST',
    body: formData,
  };

  const response = yield call(authRequest, params);
  const { id: datos, success } = response;
  const { id: idOrig } = datos;
  if (success) {
    yield (put(resetEventos()));
    yield (put(getAgendaAction(1, 0, 9999, '1,2', new Date(fecha_hora))));
  }
}

export function* getAgendaRequest() {
  yield takeLatest(GET_AGENDA_REQUEST, getAgenda);
}

export function* setCompletadoEventoRequest() {
  yield takeLatest(SET_COMPLETADO_EVENTO, setCompletadoEvento);
}

export function* deleteEventRequest() {
  yield takeLatest(DELETE_EVENT, deleteEvent);
}

export function* createEventRequest() {
  yield takeLatest(CREATE_EVENT, createEvent);
}

export function* updateEventRequest() {
  yield takeLatest(UPDATE_EVENT, updateEvent);
}
